module.exports = __webpack_public_path__ + "static/media/cellphone-thats.e15d50cd.svg";